import { ElMessage, ElMessageBox } from "element-plus";
import { h } from "vue";

import { createIntl, createIntlCache } from "@formatjs/intl";
import constant from "./constant.js";

import store from "@/store";

const intl = createIntl(
  {
    locale: "zh-CN",
    messages: {},
  },
  createIntlCache()
);

/**金额格式化 */
export const priceFormat = (num, n = 2) => {
  return intl.formatNumber(num, {
    minimumFractionDigits: n,
  });
};

export const numberFormat = (value) => {
  return priceFormat(value, 0);
};

/* 带提示框的通用请求接口函数
 * func：请求接口
 * id：数据Id
 * backFunc：回调
 * message：提示语
 */
export const confirm_func = (func, id, backFunc, message = "确认删除?") => {
  ElMessageBox.confirm(message, "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    dangerouslyUseHTMLString: true,
    type: "warning",
  }).then(() => {
    func(id).then((res) => {
      if (res.status == 200) {
        ElMessageBox.alert(res.data.msg, "提示", {
          dangerouslyUseHTMLString: true,
          type: "success",
          callback: () => {
            backFunc();
          },
        });
      } else {
        ElMessage({
          message: res.data.msg,
          type: "error",
        });
      }
    });
  });
};

//提交接口处理函数
export const post_response = (res, emit) => {
  if (res.status == 200) {
    ElMessage({
      message: res.data.msg,
      showClose: true,
      grouping: true,
      dangerouslyUseHTMLString: true,
      type: "success",
    });
    setTimeout(() => {
      emit("close", true);
    }, 500);
  }
};

//权限验证
export const judge_auth = (qxs) => {
  if (Array.isArray(qxs)) {
    return (
      store.state.loginUser?.is_super_auth == 1 ||
      store.state.loginUser?.codes?.some((w) => qxs.includes(w))
    );
  } else {
    return (
      store.state.loginUser?.is_super_auth == 1 ||
      store.state.loginUser?.codes?.includes(qxs)
    );
  }
};

//状态字段格式化，添加颜色
export const statusFormat = (item) => {
  return h("text", { style: "color:" + item?.Color }, item?.Text || "-");
};

/**
 * 状态格式化，返回vue的h对象
 * arr   数组名称（constant文件中配置的数组）
 * value 状态的值
 */
export const statusFormat2 = (arrName, value) => {
  const item = constant[arrName]?.find((w) => w.Key == value);
  if (item != null)
    return h("text", { style: "color:" + item?.Color }, item?.Text || "-");
  else return "";
};

//判断是否数字
export const judgeNumber = (value) => {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

//判断数字是否为空或0
export const numberIsNullOrZero = (value) => {
  return !value || value == 0;
};

//内容超过指定行数显示省略号  默认2行
export const showToolTip = (value, line = 2) => {
  return h("div", {
    innerHTML: value || "-",
    style:
      "display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: " +
      line +
      ";overflow: hidden;text-overflow: ellipsis;",
  });
};
